
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#EF7391","fill-opacity":".15"}}),_c('path',{attrs:{"d":"M8 12a.8.8 0 100-1.6.8.8 0 000 1.6zM8 9.6a.747.747 0 01-.566-.273 1.018 1.018 0 01-.234-.66V4.933c0-.247.084-.485.234-.66A.747.747 0 018 4c.212 0 .416.098.566.273.15.175.234.413.234.66v3.734c0 .247-.084.485-.234.66A.747.747 0 018 9.6z","fill":"#E7335E"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"15","height":"15","rx":"7.5","stroke":"#E7335E","stroke-opacity":".8"}})])
          )
        }
      }
    